import { ReactFlowProvider } from "@xyflow/react";
import { observer } from "mobx-react-lite";
import React from "react";

import { FlowVersion } from "src/api/flowTypes";
import { FloatingWindowsProvider } from "src/base-components/FloatingWindow/FloatingWindowsProvider";
import { AuthoringUIProvider } from "src/flowContainer/AuthoringUIContext";
import { RightPane } from "src/flowContainer/RightPane";
import { VersionAuthoringHeader } from "src/flowContainer/VersionAuthoringHeader";
import { DecisionGraph } from "src/flowGraph/DecisionGraph";
import { useDocumentTitle } from "src/hooks/useDocumentTitle";
import { AuthoringLayout } from "src/layout/AuthoringLayout";
import { OmniboxAuthoring } from "src/omnibox/OmniboxAuthoring";
import { useAuthoringContext } from "src/router/routerContextHooks";

const GraphAndRightSidePane: React.FC<{
  version: FlowVersion;
}> = ({ version }) => {
  if (!(version.graph_id && version.graph)) {
    return <></>;
  }
  return (
    <>
      <DecisionGraph />
      <RightPane />
    </>
  );
};

export const VersionAuthoringWrapper: React.FC = observer(() => {
  const { flow, version } = useAuthoringContext();

  useDocumentTitle([version.name, flow.name, "Decision Flows"]);

  return (
    <ReactFlowProvider>
      <OmniboxAuthoring />
      <AuthoringUIProvider>
        <FloatingWindowsProvider>
          <AuthoringLayout Header={<VersionAuthoringHeader />}>
            <div className="flex h-full w-full flex-row">
              <GraphAndRightSidePane version={version} />
            </div>
          </AuthoringLayout>
        </FloatingWindowsProvider>
      </AuthoringUIProvider>
    </ReactFlowProvider>
  );
});
